import { Outlet, useLocation } from 'react-router';
import { isSettingsHubPath } from '../../lib/nav-paths.ts';

export function SettingsLayout() {
  const location = useLocation();
  if (!isSettingsHubPath(location.pathname)) {
    return <Outlet />;
  }

  return (
    <div className="mx-auto max-w-4xl">
      <Outlet />
    </div>
  );
}
